import axios from "axios"
import library from "../../../utils/Library"

export const getAllSubscriptionDelegationsVE = async (params) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("legal_communications") +
    "/getAllSubscriptionDelegationsVE"

  return await axios({
    url: URL,
    method: "GET",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
    params,
  })
}
